import { ProductionJobShared } from "@models/production-job-shared.model";
import { SharedExportResource, SharedExportResponse } from "@models/resource/shared-export.resource";
import { MapperBase } from "@utilities/mapper-base";

export class SharedExportResourceToProductionJobSharedMapper extends MapperBase<SharedExportResponse, ProductionJobShared> {
    public map(source: SharedExportResponse): ProductionJobShared {
		if(source.success){
			const sharedExport = source?.export as SharedExportResource;
			const dest = new ProductionJobShared();
			dest.sharedId = sharedExport?.id;
			dest.productionJobId = sharedExport?.exportId;
			dest.downloadPassword = sharedExport?.passwordHash;
			dest.expires = sharedExport?.expires;
			return dest;
		}
		return null;
    }
}